import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMember,
  BackendMutationUpdateCustomerMemberDefaultWorkspaceArgs,
} from 'src/types/backend';

import { CUSTOMER_MEMBER_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomerMemberDefaultWorkspace(
    $customerId: ID!
    $memberUserId: ID!
    $defaultWorkspaceId: ID
  ) {
    updateCustomerMemberDefaultWorkspace(
      customerId: $customerId
      memberUserId: $memberUserId
      defaultWorkspaceId: $defaultWorkspaceId
    ) {
      ...CustomerMember
    }
  }
  ${CUSTOMER_MEMBER_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomerMemberDefaultWorkspaceArgs;
type Result = BackendCustomerMember;

export const updateCustomerMemberDefaultWorkspace = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
